import {
  Dropdown,
  Menu,
  Modal,
  Pagination,
  PaginationProps,
  Table,
  message,
} from "antd";
import { ExclamationCircleOutlined, LoadingOutlined } from "@ant-design/icons";
import { useDispatch, useSelector } from "react-redux";
import React, { useEffect, useState } from "react";
import CatalogHeader from "../../../components/_shared/CatalogHeader";
import { RootState } from "../../../redux/rootReducer";
import {
  deleteLabel,
  resetLabels,
  retrieveLabels,
} from "../../../redux/actions/labelActions";
import tableUtils from "../../../utils/tableUtils";
import { LabelColumn } from "../../../shared/table/columns";
import { Actions, PageSize } from "../../../shared/constant";
import icons from "../../../shared/icons";
import LabelModalForm from "../../../components/catalog/LabelModalForm";
import SearchComponent from "../../../components/_shared/SearchComponent";
import globalUtils from "../../../utils/globalUtils";
import { isClapAdminORClapManager } from "../../../utils/clapUtils";

function Labels() {
  const [visible, setVisible] = useState(false);
  // const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]);
  const dispatch = useDispatch();
  const [searchText, setSearchText] = useState("");
  const [page, setPage] = useState(1);
  const [mode, setMode] = useState("");
  const [editData, setEditData] = useState(null);
  const [effect, setEffect] = useState(false);
  const { labels, labelCount, fulfilled, pending, labelsPending } = useSelector(
    (state: RootState) => state.label,
  );
  const { userDetails } = useSelector((state: RootState) => state.user);

  useEffect(() => {
    dispatch(resetLabels());
  }, []);

  useEffect(() => {
    dispatch(
      retrieveLabels({
        page,
        searchText,
      }),
    );
  }, [page, effect]);

  const handleSearch = (value: string) => {
    setSearchText(value);
    setPage(1);
    setEffect(!effect);
  };

  const handlePageChange: PaginationProps["onChange"] = (p) => {
    setPage(p);
  };

  const onCreate = () => {
    setMode(Actions.CREATE);
    setVisible(true);
  };

  const hideModal = () => {
    setVisible(false);
    setMode("");
    setEditData(null);
  };

  const callEffect = () => {
    setEffect(!effect);
  };

  /*   const onSelectChange = (newSelectedRowKeys: React.Key[]) => {
    setSelectedRowKeys(newSelectedRowKeys);
  };

  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
  }; */

  useEffect(() => {
    if (mode === Actions.DELETE) {
      if (fulfilled) {
        message.success("Label successfully deleted");
        setMode("");
        if (labels.length === 1 && page > 1) setPage(page - 1);
        setEffect(!effect);
      }
    }
  }, [pending]);

  const onEdit = (record: any) => {
    setMode(Actions.EDIT);
    setVisible(true);
    setEditData(record);
  };

  const onDelete = (record: any) => {
    Modal.confirm({
      title: "Are you sure to delete this Label?",
      icon: <ExclamationCircleOutlined />,
      okText: "Yes",
      cancelText: "No",
      centered: true,
      onOk: async () => {
        await dispatch(deleteLabel({ id: record.id }));
        setMode(Actions.DELETE);
      },
      onCancel() {},
    });
  };

  const actions = {
    title: "",
    key: "action",
    align: "right",
    render: (_: any, record: any) =>
      isClapAdminORClapManager(userDetails) && (
        <div className="text-secondary">
          <Dropdown
            overlay={
              <Menu
                className="min-w-[100px] rounded-[3px]"
                items={[
                  {
                    label: (
                      <div onClick={() => onEdit(record)} aria-hidden="true">
                        Edit
                      </div>
                    ),
                    key: "EDIT",
                  },
                  {
                    label: (
                      <div onClick={() => onDelete(record)} aria-hidden="true">
                        Delete
                      </div>
                    ),
                    key: "DELETE",
                  },
                ]}
              />
            }
            trigger={["click"]}
          >
            <button type="button">{icons.DotsVerticle()}</button>
          </Dropdown>
        </div>
      ),
  };

  return (
    <div>
      <div>
        <CatalogHeader title="Labels" handleClick={onCreate} />
        <LabelModalForm
          visible={visible}
          onCancel={hideModal}
          callEffect={callEffect}
          mode={mode}
          editData={editData}
        />
      </div>
      <div className="mt-5 mb-4">
        <SearchComponent handleSearch={handleSearch} />
      </div>
      <div>
        <Table
          // rowSelection={labels.length && rowSelection}
          rowKey={(record: any) => {
            return record.id;
          }}
          // columns={getColumn(labels, ["id", "logo"], true, true)}
          columns={tableUtils.buildColumns(labels, LabelColumn, actions)}
          dataSource={labels}
          pagination={false}
          size="middle"
          scroll={{
            ...(globalUtils.checkIsScroll(labels) && { y: 474 }),
            x: 1024,
          }}
          className="ant_table"
          loading={{
            spinning: labelsPending as boolean,
            indicator: <LoadingOutlined style={{ fontSize: 34 }} />,
          }}
        />
      </div>
      <div className="text-right mt-4">
        <Pagination
          current={page}
          pageSize={PageSize.FIFTY}
          onChange={handlePageChange}
          total={labelCount}
          showSizeChanger={false}
        />
      </div>
    </div>
  );
}

export default Labels;
